import classNames from 'classnames';

import { ProductReviewSkeleton } from '@components/ProductReview';

import s from './ProductDetailsReviews.sss';

interface Props {
  className?: string,
  count: number,
}

export const ProductDetailsReviewsSkeleton: React.FC<Props> = ({
  className,
  count,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <ul className={s.list}>
        {[...Array(count)].map((_, i) => (
          <li
            key={i}
            className={s.item}
          >
            <ProductReviewSkeleton />
          </li>
        ))}
      </ul>
    </div>
  );
};
